<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd()">
        <div class="flex-1 font-16-30313a">岗位分组</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="stationClassifyList && stationClassifyList.length > 0">
        <cate-menu :menu-data="stationClassifyList" :not-add="true" @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex mb-10">
          <div class="btn-24-bg-ff flex align-center mr-5" @click="onAddStation">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增岗位
          </div>
        </div>
        <div class="flex-1 mb-10">
          <erp-table :is-edit="true" ref="erpTable" :table-data="stationList" :loading="loading"  @on-modify="onModifyStation" modify-method="on-modify"
                     :column-data="columnData" @on-delete-station="onDeleteStation" @on-open-function="onOpenFunction" @set-auditor="setAuditor"
                     @on-open-change="onOpenChange" @on-open-bill="onOpenBill" @on-open-report="onOpenReport"></erp-table>
        </div>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="岗位分组" :visible.sync="isClassifyShow" @closed="onCloseClassify">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">岗位分组名称：</div>
          <el-input v-model="newClassify.name" class="flex-1" placeholder="请输入分组名称"></el-input>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">岗位分组说明：</div>
          <el-input type="textarea" v-model="newClassify.remark" :row="3" class="flex-1" placeholder="请输入分组说明"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseClassify">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitClassify">确定</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="80%" :title="currentStation.name + ' 报表权限'" :visible.sync="isReportShow">
      <div class="bg-ff font-12-ff5555 text-left align-center ptb-8 border-b-e2 pl-20">
        <i class="el-icon-warning mr-5"></i>
        提示：切换“报表分类”时请先点击【保存】按钮！
      </div>
      <div class="flex" style="height: 526px; border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
        <div class="dialog-left">
          <el-scrollbar class="h-100 hide-x">
            <div class="dialog-left-top">
              报表分类
            </div>
            <div v-for="(item, index) in reportList" class="station-item" :class="{'active' : item.id === currentReport.id}" @click="onChooseReport(item)" :key="index">
              <div class="index-tip">{{index + 1}}</div>
              <div>{{item.name}}</div>
            </div>
          </el-scrollbar>
        </div>
        <div class="dialog-right shrink0" style="min-width: 580px">
          <div class="h-100">
            <el-scrollbar class="h-100 hide-x">
              <div class="dialog-menu-item">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">全选</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox v-model="checkAll" @change="allSelect"></el-checkbox>
                </div>
              </div>
              <div v-for="(item, index) in currentReport.children" class="dialog-menu-item align-center" :class="{'active' : item.isChecked}" @click="onClickReport(item)" :key="index">
                <div class="flex-1 flex align-center">
                  <el-tooltip  effect="dark" :content="item.name" placement="top">
                    <div class="text-overflow">{{item.name}}</div>
                  </el-tooltip>
                </div>
                <img :src="reportStr.indexOf(item.id + ',') > -1 ? '/static/images/xuanzhong.png' : '/static/images/weixuan.png'" class="icon-16" alt="">
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="isReportShow = false">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitReport">确定</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="80%" :title="currentStation.name + ' 功能权限设置'" :visible.sync="isFunctionShow" @closed="onCloseFunction">
      <div class="bg-ff font-12-ff5555 text-left align-center ptb-8 border-b-e2 pl-20">
        <i class="el-icon-warning mr-5"></i>
        提示：切换“功能模块”及“用户分类”时请先点击【保存】按钮！
      </div>
      <div class="flex bg-f3f4f7" style="height: 560px">
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            功能模块
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in functionList" class="dialog-menu-item" :class="{'active' : item.isChecked, 'current': item.id === currentFunction.id}" :key="index" @click="onClickFunction(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <div @click.stop="()=>{}">
                <el-checkbox v-model="item.isChecked"></el-checkbox>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            用户分类
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in functionChildren" class="dialog-menu-item" :class="{'active' : item.isChecked, 'current': item.id === currentSecondFunction.id}" :key="index" @click="onClickFunctionChild(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <div @click.stop="()=>{}">
                <el-checkbox v-model="item.isChecked"></el-checkbox>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column dialog-half">
          <div class="dialog-left-top">
            功能按钮
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div class="dialog-menu-item" :class="{'active' : btnCheckAll}" v-if="btnList.length>0">
              <div class="flex-1 flex align-center">
                <span class="flex-1">全选</span>
              </div>
              <div @click.stop="()=>{}" @change="allBtnSelect">
                <el-checkbox v-model="btnCheckAll"></el-checkbox>
              </div>
            </div>
            <div v-for="(item, index) in btnList" class="dialog-menu-item" :class="{'active' : item.isChecked}" :key="index" @click="onClickBtn(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <div @click.stop="()=>{}">
                <el-checkbox v-model="item.isChecked"></el-checkbox>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseFunction">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitFunction">保存</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="80%" :title="currentStation.name + ' 单据权限设置'" :visible.sync="isBillShow" @closed="onCloseBill">
      <div class="bg-ff font-12-ff5555 text-left align-center ptb-8 border-b-e2 pl-20">
        <i class="el-icon-warning mr-5"></i>
        提示：切换时请先点击【保存】按钮！
      </div>
      <div class="flex bg-f3f4f7" style="height: 560px">
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            单据分类
          </div>
          <div class="flex-1 h-0">
            <el-scrollbar class="h-100 hide-x">
              <div class="dialog-menu-item" v-if="orderTypeFirstList && orderTypeFirstList.length > 0">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">全选</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox v-model="checkFirst" @change="chooseAllFirst"></el-checkbox>
                </div>
              </div>
              <div v-for="(item, index) in orderTypeFirstList" class="dialog-menu-item" :class="{'active' : item.isChecked, 'current': item.id === orderTypeFirst.id}" :key="index" @click="getOrderType(2, item)">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">{{item.name}}</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox @change="cancelCheckFirst" v-model="item.isChecked"></el-checkbox>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div style="height: 50px; border-top: 1px solid #e2e2e2;" class="flex justify-center align-center">
            <div class="btn-30-bg-f5971d-s" @click="submitOrderType(1)">保存</div>
          </div>
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            单据流程
          </div>
          <div class="flex-1 h-0">
            <el-scrollbar class="h-100 hide-x">
              <div class="dialog-menu-item" v-if="orderTypeSecondList && orderTypeSecondList.length > 0">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">全选</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox v-model="checkSecond" @change="chooseAllSecond"></el-checkbox>
                </div>
              </div>
              <div v-for="(item, index) in orderTypeSecondList" class="dialog-menu-item" :class="{'active' : item.isChecked, 'current': item.id === orderTypeSecond.id}" :key="index" @click="getOrderType(3, item)">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">{{item.name}}</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox @change="cancelCheckSecond" v-model="item.isChecked"></el-checkbox>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div style="height: 50px; border-top: 1px solid #e2e2e2;" class="flex justify-center align-center">
            <div class="btn-30-bg-f5971d-s" @click="submitOrderType(2)">保存</div>
          </div>
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column dialog-half">
          <div class="dialog-left-top">
            单据按钮
          </div>
          <div class="flex-1 h-0">
            <el-scrollbar class="h-100 hide-x">
              <div class="dialog-menu-item" v-if="orderTypeThirdList && orderTypeThirdList.length > 0">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">全选</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox v-model="checkThird" @change="chooseAllThird"></el-checkbox>
                </div>
              </div>
              <div v-for="(item, index) in orderTypeThirdList" class="dialog-menu-item" :class="{'active' : item.isChecked}" :key="index">
                <div class="flex-1 flex align-center">
                  <span class="flex-1">{{item.name}}</span>
                </div>
                <div @click.stop="()=>{}">
                  <el-checkbox @change="cancelCheckThird" v-model="item.isChecked"></el-checkbox>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div style="height: 50px; border-top: 1px solid #e2e2e2;" class="flex justify-center align-center">
            <div class="btn-30-bg-f5971d-s" @click="submitOrderType(3)">保存</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="326px" title="更换分类" :visible.sync="isChangeShow" @closed="onCloseChange">
      <div class="flex">
        <div class="p-20 w-100">
          <div class="flex align-center mb-10 w-100">
            <div class="font-12-30313a mr-5">岗位分组：</div>
            <el-select v-model="currentStation.classifyId" class="flex-1" placeholder="请选择要调整到的岗位组别">
              <el-option
                v-for="item in stationClassifyList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseChange">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="submitChange">保存</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'stationDefine',
  components: {CateMenu, MoveHorizon, ErpTable},
  data () {
    return {
      chooseMenuId: 0,
      stationClassifyList: [],
      stationList: [],
      stationClassify: {},
      isClassifyShow: false,
      isReportShow: false,
      isFunctionShow: false,
      isBillShow: false,
      isChangeShow: false,
      loading: false,
      newClassify: {},
      columnData: [
        {
          field: 'operate',
          title: '操作',
          width: '440',
          isDefine: true,
          child: [{
            className: 'btn-16-bd-85 btn-hover mr-5',
            title: '功能权限',
            methodName: 'on-open-function',
            type: 'btn'
          }, {
            className: 'btn-16-bd-85 btn-hover mr-5',
            title: '单据权限',
            methodName: 'on-open-bill',
            type: 'btn'
          }, {
            className: 'btn-16-bd-85 btn-hover mr-5',
            title: '报表权限',
            methodName: 'on-open-report',
            type: 'btn'
          }, {
            className: 'btn-16-bg-85 btn-hover mr-5',
            title: '更换分类',
            methodName: 'on-open-change',
            type: 'btn'
          }, {
            className: 'btn-16-bd-ff5555',
            title: '删除',
            methodName: 'on-delete-station',
            type: 'btn'
          }]
        },
        {
          field: 'isMaterialAuditor',
          title: '材料审核员',
          width: '90',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isMaterialAuditor',
            methodName: 'set-auditor',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'name',
          title: '岗位名称',
          width: '200',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'remark',
          title: '岗位说明',
          minWidth: '250',
          editRender: {
            name: 'textarea'
          }
        }
      ],
      currentFunction: {},
      functionList: [],
      currentSecondFunction: {},
      functionChildren: [],
      currentStation: {},
      btnList: [],
      orderTypeFirstList: [],
      orderTypeSecondList: [],
      orderTypeThirdList: [],
      orderTypeFirst: {},
      orderTypeSecond: {},
      checkFirst: false,
      checkAll: false,
      checkSecond: false,
      checkThird: false,
      reportList: [],
      currentReport: {},
      reportStr: '',
      btnCheckAll: false
    }
  },
  created () {
    this.getStationClassify(true)
    this.axios.post('reportClassify/findAll', {type: 1, companyId: this.$store.state.companyId}).then(res => {
      if (res.data.success) {
        this.reportList = res.data.data
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () {},
  methods: {
    allSelect () {
      let reportStr = []
      if (this.checkAll) {
        for (let i = 0; i < this.currentReport.children.length; i++) {
          reportStr += (this.currentReport.children[i].id + ',')
        }
      }
      this.reportStr = reportStr
    },
    allBtnSelect () {
      for (let i = 0; i < this.btnList.length; i++) {
        this.btnList[i].isChecked = this.btnCheckAll
      }
    },
    cancelCheckFirst (checked) {
      if (!checked) {
        this.checkFirst = false
      }
    },
    cancelCheckSecond (checked) {
      if (!checked) {
        this.checkSecond = false
      }
    },
    cancelCheckThird (checked) {
      if (!checked) {
        this.checkThird = false
      }
    },
    submitReport () {
      let params = []
      for (let i = 0; i < this.currentReport.children.length; i++) {
        let report = this.currentReport.children[i]
        if (this.reportStr.indexOf(report.id + ',') > -1) {
          params.push({
            roleId: this.currentStation.id,
            companyId: this.$store.state.companyId,
            reportId: report.id,
            classifyId: this.currentReport.id
          })
        }
      }
      if (params.length === 0) {
        params.push({
          roleId: this.currentStation.id,
          companyId: this.$store.state.companyId,
          classifyId: this.currentReport.id
        })
      }
      this.axios.post('reportPermission/save', params).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onClickReport (report) {
      if (this.reportStr.indexOf(report.id + ',') > -1) {
        this.reportStr = this.reportStr.replace(report.id + ',', '')
      } else {
        this.reportStr += (report.id + ',')
      }
    },
    onOpenReport (row) {
      this.currentStation = row
      this.isReportShow = true
      this.currentReport = this.reportList.length > 0 ? this.reportList[0] : {}
      if (this.reportList.length > 0) {
        this.getReportStr()
      }
    },
    getReportStr () {
      this.axios.post('reportPermission/listStr', {companyId: this.$store.state.companyId, classifyId: this.currentReport.id, roleId: this.currentStation.id}).then(res => {
        if (res.data.success) {
          this.reportStr = res.data.data
          // let checkAll = false
          // for (let i = 0; i < this.currentReport.children.length; i++) {
          //   if (this.reportStr.indexOf(this.currentReport.children[i]) > 0) {
          //     checkAll = true
          //   } else {
          //     checkAll = false
          //   }
          // }
          // this.checkAll = checkAll
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseReport (report) {
      this.checkAll = false
      this.currentReport = report
      this.getReportStr()
    },
    submitChange () {
      this.axios.post('station/modify', {id: this.currentStation.id, classifyId: this.currentStation.classifyId}).then(res => {
        if (res.data.success) {
          this.$message.success('调整成功')
          this.getStation()
          this.isChangeShow = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onOpenChange (row) {
      this.currentStation = row
      this.isChangeShow = true
    },
    onCloseChange () {
      this.isChangeShow = false
    },
    chooseAllFirst (checked) {
      let dataList = []
      if (checked) {
        for (let i = 0; i < this.orderTypeFirstList.length; i++) {
          dataList.push({
            ...this.orderTypeFirstList[i],
            isChecked: true
          })
        }
      } else {
        for (let i = 0; i < this.orderTypeFirstList.length; i++) {
          dataList.push({
            ...this.orderTypeFirstList[i],
            isChecked: false
          })
        }
      }
      this.orderTypeFirstList = dataList
    },
    chooseAllSecond (checked) {
      let dataList = []
      if (checked) {
        for (let i = 0; i < this.orderTypeSecondList.length; i++) {
          dataList.push({
            ...this.orderTypeSecondList[i],
            isChecked: true
          })
        }
      } else {
        for (let i = 0; i < this.orderTypeSecondList.length; i++) {
          dataList.push({
            ...this.orderTypeSecondList[i],
            isChecked: false
          })
        }
      }
      this.orderTypeSecondList = dataList
    },
    chooseAllThird (checked) {
      let dataList = []
      if (checked) {
        for (let i = 0; i < this.orderTypeThirdList.length; i++) {
          dataList.push({
            ...this.orderTypeThirdList[i],
            isChecked: true
          })
        }
      } else {
        for (let i = 0; i < this.orderTypeThirdList.length; i++) {
          dataList.push({
            ...this.orderTypeThirdList[i],
            isChecked: false
          })
        }
      }
      this.orderTypeThirdList = dataList
    },
    submitOrderType (step) {
      let dataList = []
      switch (step) {
        case 1:
          for (let i = 0; i < this.orderTypeFirstList.length; i++) {
            if (this.orderTypeFirstList[i].isChecked) {
              dataList.push({
                roleId: this.currentStation.id,
                orderType: this.orderTypeFirstList[i].id,
                step
              })
            }
          }
          if (dataList.length === 0) {
            dataList.push({
              roleId: this.currentStation.id,
              step
            })
          }
          break
        case 2:
          for (let i = 0; i < this.orderTypeSecondList.length; i++) {
            if (this.orderTypeSecondList[i].isChecked) {
              dataList.push({
                roleId: this.currentStation.id,
                orderType: this.orderTypeFirst.id,
                orderStatus: this.orderTypeSecondList[i].id,
                step
              })
            }
          }
          if (dataList.length === 0) {
            dataList.push({
              roleId: this.currentStation.id,
              orderType: this.orderTypeFirst.id,
              step
            })
          }
          break
        case 3:
          for (let i = 0; i < this.orderTypeThirdList.length; i++) {
            if (this.orderTypeThirdList[i].isChecked) {
              dataList.push({
                roleId: this.currentStation.id,
                button: this.orderTypeThirdList[i].permission,
                orderType: this.orderTypeFirst.id,
                orderStatus: this.orderTypeSecond.id,
                step
              })
            }
          }
          if (dataList.length === 0) {
            dataList.push({
              roleId: this.currentStation.id,
              orderType: this.orderTypeFirst.id,
              orderStatus: this.orderTypeSecond.id,
              step
            })
          }
          break
      }
      this.axios.post('orderPermission/save', dataList).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onOpenBill (row) {
      this.currentStation = row
      this.orderTypeFirstList = []
      this.orderTypeSecondList = []
      this.orderTypeThirdList = []
      this.orderTypeFirst = {}
      this.orderTypeSecond = {}
      this.checkFirst = false
      this.checkSecond = false
      this.checkThird = false
      this.getOrderType(1)
    },
    getOrderType (step, orderType) {
      switch (step) {
        case 1:
          this.axios.post('orderType/list', {roleId: this.currentStation.id}).then(res => {
            if (res.data.success) {
              this.orderTypeFirstList = res.data.data
              this.isBillShow = true
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
          break
        case 2:
          this.orderTypeFirst = orderType
          this.orderTypeThirdList = []
          this.orderTypeSecond = {}
          this.checkSecond = false
          this.checkThird = false
          let params = {
            roleId: this.currentStation.id,
            group: orderType.group,
            orderType: orderType.id
          }
          this.axios.post('orderProcess/list', params).then(res => {
            if (res.data.success) {
              this.orderTypeSecondList = res.data.data
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
          break
        case 3:
          this.orderTypeSecond = orderType
          this.checkThird = false
          let param = {
            roleId: this.currentStation.id,
            group: this.orderTypeFirst.group,
            orderType: this.orderTypeFirst.id,
            orderStatus: orderType.id
          }
          this.axios.post('orderButton/list', param).then(res => {
            if (res.data.success) {
              this.orderTypeThirdList = res.data.data
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
          break
      }
    },
    onCloseBill () {
      this.isBillShow = false
    },
    submitFunction () {
      let permissionList = []
      let flag1 = true
      for (let i = 0; i < this.functionList.length; i++) {
        if (this.functionList[i].isChecked) {
          flag1 = false
          let permission = {
            roleId: this.currentStation.id,
            permission: this.functionList[i].permission
          }
          permissionList.push(permission)
        }
      }
      if (flag1) {
        permissionList.push({
          roleId: this.currentStation.id
        })
      }
      let flag2 = true
      for (let i = 0; i < this.functionChildren.length; i++) {
        if (this.functionChildren[i].isChecked) {
          flag2 = false
          let permission = {
            roleId: this.currentStation.id,
            parent: this.currentFunction.permission,
            permission: this.functionChildren[i].permission
          }
          permissionList.push(permission)
        }
      }
      if (flag2 && this.functionChildren.length > 0) {
        permissionList.push({
          parent: this.currentFunction.permission,
          roleId: this.currentStation.id
        })
      }
      let flag3 = true
      for (let i = 0; i < this.btnList.length; i++) {
        if (this.btnList[i].isChecked) {
          flag3 = false
          let permission = {
            roleId: this.currentStation.id,
            parent: this.currentSecondFunction.permission,
            permission: this.btnList[i].permission
          }
          permissionList.push(permission)
        }
      }
      if (flag3 && this.btnList.length > 0) {
        permissionList.push({
          parent: this.currentSecondFunction.permission,
          roleId: this.currentStation.id
        })
      }
      let that = this
      this.axios.post('permission/setPermission', permissionList).then(res => {
        if (res.data.success) {
          this.$confirm('设置成功, 是否继续设置?', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
          }).catch(() => {
            that.isFunctionShow = false
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onClickBtn (data, index) {
      let functionInfo = this.btnList[index]
      functionInfo.isChecked = !functionInfo.isChecked
      this.$set(this.btnList, index, functionInfo)
      if (this.btnList.length > 0) {
        this.btnCheckAll = true
        for (let i = 0; i < this.btnList.length; i++) {
          if (!this.btnList[i].isChecked) {
            this.btnCheckAll = false
            return
          }
        }
      }
    },
    onClickFunctionChild (data, index) {
      if (data.id !== this.currentSecondFunction.id) {
        this.currentSecondFunction = data
        this.getFunction(2)
      }
    },
    onClickFunction (data, index) {
      if (data.id !== this.currentFunction.id) {
        this.currentFunction = data
        this.getFunction(1)
      }
    },
    onOpenFunction (row) {
      this.currentStation = row
      this.getFunction(0)
    },
    onCloseFunction () {
      this.isFunctionShow = false
    },
    getFunction (isChild) {
      this.btnList = []
      let params = {
        roleId: this.currentStation.id,
        isRoot: isChild === 0
      }
      if (isChild === 1) {
        params.parent = this.currentFunction.permission
        params.parentGroup = this.currentFunction.group
      } else if (isChild === 2) {
        params.parent = this.currentSecondFunction.permission
        params.parentGroup = this.currentSecondFunction.group
      }
      this.axios.post('permissionDefine/list', params).then(res => {
        if (res.data.success) {
          if (isChild === 1) {
            this.functionChildren = res.data.data
            if (res.data.data.length > 0) {
              this.currentSecondFunction = res.data.data[0]
              this.getFunction(2)
            }
          } else if (isChild === 2) {
            this.btnList = res.data.data
            if (this.btnList.length > 0) {
              this.btnCheckAll = true
              for (let i = 0; i < this.btnList.length; i++) {
                if (!this.btnList[i].isChecked) {
                  this.btnCheckAll = false
                  return
                }
              }
            }
          } else {
            this.functionList = res.data.data
            if (res.data.data.length > 0) {
              this.currentFunction = res.data.data[0]
              this.getFunction(1)
            }
          }
          this.isFunctionShow = true
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onDeleteStation (row) {
      let that = this
      this.$confirm('此操作将永久删除该岗位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('station/deleteById', this.qs.stringify({id: row.id})).then(res => {
          if (res.data.success) {
            that.getStation()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      })
    },
    setAuditor (row) {
      this.onModifyStation(row, null, 'isMaterialAuditor')
    },
    onModifyStation (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('station/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
          this.$refs.erpTable.revertData(row)
        }
      })
    },
    onAddStation () {
      this.axios.post('station/save', {classifyId: this.chooseMenuId}).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.stationList[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.stationClassify = menu
        this.chooseMenuId = menu.id
        this.getStation()
      }
    },
    onDelete (menu) {
      let that = this
      this.$confirm('此操作将永久删除该岗位分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('stationClassify/deleteById', this.qs.stringify({id: menu.id})).then(res => {
          if (res.data.success) {
            that.getStationClassify(that.chooseMenuId === menu.id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onEdit (menu) {
      this.newClassify = {
        id: menu.id,
        name: menu.name,
        remark: menu.remark
      }
      this.isClassifyShow = true
    },
    onAdd () {
      this.isClassifyShow = true
    },
    submitClassify () {
      if (!this.newClassify.name) {
        this.$message.warning('请输入分组名称')
      } else {
        this.newClassify.companyId = this.$store.state.companyId
        let url = 'stationClassify/save'
        let type = '新增'
        if (this.newClassify.id) {
          url = 'stationClassify/modify'
          type = '修改'
        }
        this.axios.post(url, this.newClassify).then(res => {
          if (res.data.success) {
            this.$message.success(type + '岗位分组成功')
            this.getStationClassify()
            this.isClassifyShow = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onCloseClassify () {
      this.isClassifyShow = false
      this.newClassify = {}
    },
    getStation () {
      this.loading = true
      this.axios.post('station/list', {
        classifyId: this.stationClassify.id,
        status: 1
      }).then(res => {
        this.loading = false
        if (res.data.success) {
          this.stationList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offsetTop: 400
          })
        }
      })
    },
    getStationClassify (isRefresh) {
      this.stationClassifyList = []
      // this.axios.post('stationClassify/list', {companyId: this.$store.state.companyId}).then(res => {
      this.axios.post('stationClassify/list', {}).then(res => {
        if (res.data.success) {
          this.stationClassifyList = res.data.data
          if (isRefresh && res.data.data.length > 0) {
            this.stationClassify = res.data.data[0]
            this.chooseMenuId = res.data.data[0].id
            this.getStation()
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offsetTop: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }
  .dialog-menu-item {
    height: 35px;
    line-height: 35px;
    display: flex;
    padding: 0 20px;
    font-size: 12px;
    color: #30313a;
    text-align: left;
    cursor: pointer;
    &.active {
      color: #f5971d;
    }
    &.current {
      color: #f5971d;
      background: #f3f4f7;
    }
  }
  .dialog-left {
    width: 200px;
    min-width: 150px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 6px;
    z-index: 9;
    .station-item {
      cursor: pointer;
      display: flex;
      padding: 0 20px;
      align-items: center;
      font-size: 14px;
      color: #30313a;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px dashed #e2e2e2;
      .index-tip {
        width: 20px;
        text-align: center;
        height: 14px;
        line-height: 14px;
        background-color: #b9b9b9;
        border-radius: 4px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
      }
      &.active {
        color: #f5971d;
        .index-tip {
          background-color: #f5971d;
          color: #ffffff;
        }
      }
    }
  }
  .dialog-right {
    border-bottom-right-radius: 6px;
    flex: 1;
    background-color: #f3f4f7;
    padding: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/stationDefine.vue